import React, { Fragment } from "react";
import { Helmet } from "react-helmet";
import NavBar from "components/NavBar";
import { Footer, AppContainer } from "styles/components/Layout";

const Layout = (props) => {
  const paddingTop = 10
  return (
    <Fragment>
      <Helmet>
        <meta name="viewport" content="width=device-width" />
      </Helmet>
      <div className="app-container">
        <NavBar activeTab={props?.activeTab} />
        <AppContainer
          className={`app-body ${paddingTop ? "app-body-top-padding" : ""} `}
        >
          {props?.children}
        </AppContainer>
        <Footer>
        </Footer>
      </div>
    </Fragment>
  );
};

export default Layout;
